import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getPage = createSelector(
  property('page'),
  identity
);
export const isLoaded = createSelector(
  getPage,
  property('isLoaded')
);
export const getError = createSelector(
  getPage,
  property('error')
);



// WEBPACK FOOTER //
// ./src/modules/PageDetail/selectors/index.js